import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fillRule="evenodd" xmlns="http://www.w3.org/2000/svg" {...props}><path clipRule="evenodd" d="M15.5 7L9 14l-4-4 .79-.791L9 12.461l5.71-6.25.79.789z" /></svg>;